var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{class:_vm.cssClass,attrs:{"color":_vm.color,"x-small":_vm.xSmall,"text-color":"white","link":""},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onClickHandler.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }